/**
 * Disable invalid Form
 *
 * @package:  Monapix
 * @version:  3.0.1
 * @author:   Cyrill N KALITA
 */

(function() {

    'use strict';

    window.addEventListener('load', function() {
        // Fetch all the forms we want to apply custom Bootstrap validation styles to
        var forms = document.getElementsByClassName('needs-validation');
        // Loop over them and prevent submission
        var validation = Array.prototype.filter.call(forms, function(form) {
            // for each form that requires validation, attach event listener
            form.addEventListener('submit', function(event) {
                // use Javscript validation API
                // https://www.w3schools.com/js/js_validation_api.asp
                if (form.checkValidity() === false) {
                    event.preventDefault();
                    event.stopPropagation();
                }
                // validate the form
                form.classList.add('was-validated');
            }, false);
        });
    }, false);
})();



// WEBPACK FOOTER //
// ./resources/js/services/jquery/validation.js